
const nameList = [
    {
        entityField: "bgmName",
        showField: "通用名字",
        fieldWeight: 70,
        fieldType: "string",

    },
    {
        entityField: "spec",
        showField: "规格",
        fieldWeight: 100,
        fieldType: "string",

    },
  
    {
        entityField: "point",
        showField: "积分",
        fieldWeight: 100,
        fieldType: "string",

    },

    {
        entityField: "manufacturer",
        showField: "生产商",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "placeorigin",
        showField: "产地",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "remark",
        showField: "备注",
        fieldWeight: 100,
        fieldType: "string",

    },

]

const searchList = [


    {
        showField: "通用名称",    
        entityField: "bgmName",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },


]





export { nameList, searchList }